<template>
    <div
        id="form-app"
        @click.self="select(null)"
    >
        <rent
            v-if="type === 'rent'"
            :strtime="data.time"
            @select="select"
        />
        <tours
            v-if="type === 'tour'"
            @select="select"
        />
    </div>
</template>

<script>
import Rent from './components/Rent';
import Tours from './components/Tours';

export default {
    name: 'from-app',
    props: {
        type: {
            type: String,
            required: true
        },
        data: {
            type: Object,
            required: true
        }
    },
    methods: {
        select(data) {
            this.$emit('select', data);
        }
    },
    components: {
        Rent,
        Tours
    }
};
</script>



// WEBPACK FOOTER //
// src/FormApp.vue